import { useEffect, useState } from 'react';
import { ChevronRight, FolderOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { loadMiscCategories, loadMiscCategoryCounts } from '../lib/library';
import type { MiscCategory } from '../lib/library';
import { ErrorState, LoadingState } from '../components/ui';

const TONES = ['tone-a', 'tone-b', 'tone-c', 'tone-d'];

export function StudentLibrary() {
  const [categories, setCategories] = useState<MiscCategory[]>();
  const [counts, setCounts] = useState<Map<string, number>>();
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    void (async () => {
      try {
        const rows = await loadMiscCategories();
        if (!active) return;
        setCategories(rows);
        setCounts(await loadMiscCategoryCounts(rows));
      } catch {
        if (active) setFailed(true);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  return <div className="library-page">
    <section className="utility-hero"><div className="utility-icon"><FolderOpen size={28} /></div><div><h1>Library</h1><p>Image banks, result sheets, notes, and updates from AyurGuide faculty.</p></div></section>
    {loading ? <LoadingState /> : failed || !categories ? <ErrorState onRetry={() => window.location.reload()} />
      : categories.length
        ? <div className="misc-grid">{categories.map((category, index) => (
          <Link className={`misc-card ${TONES[index % TONES.length]}`} key={category.objectId} to={`/library/${category.objectId}`}>
            <span className="misc-card-icon"><FolderOpen size={20} /></span>
            <strong>{category.CatName || 'Untitled collection'}</strong>
            {category.CatDesc && <small>{category.CatDesc}</small>}
            <span className="misc-card-meta">{counts?.get(category.objectId) ?? '…'} items<ChevronRight size={14} /></span>
          </Link>
        ))}</div>
        : <p className="detail-description">No collections have been published yet.</p>}
  </div>;
}
